import { Layer } from "@/Utils/hierarchy";

import { COLUMN_CONFIG_MAP, DEFAULT_COLUMNS } from "../constants/defaults";
import { FunnelStage } from "../filters";

export const getDefaultColumns = (funnelStage: string | null, nodeLayer: Layer): string[] => {
  if (!funnelStage) {
    return DEFAULT_COLUMNS.detailed;
  }

  const configKey = `${funnelStage}_${nodeLayer}`;

  if (COLUMN_CONFIG_MAP[configKey]) {
    return COLUMN_CONFIG_MAP[configKey];
  }

  return funnelStage === FunnelStage.All ? DEFAULT_COLUMNS.basic : DEFAULT_COLUMNS.detailed;
};
